/**
 * @file: GenericBooleanTypeCriterion.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { AbstractSearchCriterionProvider } from './AbstractSearchCriterionProvider';
import { SearchCriterionOption, SearchCriterionType } from './types';

export class GenericBooleanTypeCriterion<
  T extends SearchCriterionType,
> extends AbstractSearchCriterionProvider<T, boolean> {
  private readonly label: string;

  private constructor(label: string, type: T) {
    super(type);
    this.label = label;
  }

  static create<T extends SearchCriterionType>(
    label: string,
    type: T,
  ): GenericBooleanTypeCriterion<T> {
    return new GenericBooleanTypeCriterion(label, type);
  }

  getLabel(): string {
    return this.label;
  }

  internalGetDisplayText(value: boolean): string {
    return value ? '是' : '否';
  }

  internalGetOptions(): SearchCriterionOption<boolean>[] {
    return [{ value: true }, { value: false }];
  }
}
